export const TapTrainingPlanViewDirectReporteeMrgSnglTeamReducer = (state = {}, action) => {
    switch (action.type) {
      case 'POST_TRAININGPLANVIEW_DIRECTREPORTEE_MANAGERSINGLETEAM_DETAILS':
        return {
          ...state,
          directReporteeMrgerSnglTeamAPIResponse: action.payload,
        };
        
      case 'API_START':
        if (action.payload === 'FETCH_TRAININGPLANVIEW_DIRECTREPORTEE_MANAGERSINGLETEAM_DATA') {
          return {
            ...state,
            isFetchingTVManagerDRData: true,
          };
        }else {
          return state;
        }

      case 'API_END':
        if (action.payload === 'FETCH_TRAININGPLANVIEW_DIRECTREPORTEE_MANAGERSINGLETEAM_DATA') {
          return {
            ...state,
            isFetchingTVManagerDRData: false,
          };
        }else {
          return state;
        }

      default:
        return state;
    }

};
